<i18n>
    {
        "ru": {
            "headline": "Билет на просмотр"
        },
        "en": {
            "headline": "E-ticket"
        }
    }
</i18n>

<template>
    <h1 :class="$style.headline">{{ $t("headline") }}</h1>
</template>

<script>
export default {
    name: "FormHeadline",
};
</script>

<style module>
.headline {
    font-weight: 400;
    margin: 0;
}
</style>
